<template>
  <div class="flex items-center gap-2">
    <!-- Logo图标 -->
    <img src="@/assets/logo.png" alt="甜甜游戏服务网" class="h-10 w-auto" />
    <div class="flex flex-col">
      <span class="font-bold text-lg bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
        甜甜游戏服务网
      </span>
      <span class="text-xs text-gray-500 -mt-1">游戏账号交易平台</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>
